export default __webpack_public_path__ + "static/media/050-writing.a1da1664.svg";